import { Injectable } from '@angular/core';
import { JwtService } from '../services/jwt.service';

@Injectable({
  providedIn: 'root',
})
export class JwtHelper {
  constructor(private jwtService: JwtService) {}

  public decodeToken(token: string): any {
    try {
      return this.jwtService.decodeToken(token);
    } catch (error) {
      console.error('Falha ao decodificar o token: ', error);
      return null;
    }
  }

  public getClaim(token: string, claimKey: string): any {
    const decodedToken = this.decodeToken(token);
    return decodedToken ? decodedToken[claimKey] : null;
  }

  public getUserIdFromToken(): string | null {
    const storedData = localStorage.getItem('LOGIN_USER');
    if (!storedData) {
      return null;
    }

    try {
      const parsedData = JSON.parse(storedData);
      const token = parsedData?.token;
      if (token) {
        return this.getClaim(token, 'sub');
      }
    } catch (error) {
      console.error('Falha ao fazer o parse do token: ', error);
    }

    return null;
  }
}
